import {OfferProductSolutionType} from "../../../../../../../models/offer/product/solution/OfferProductSolutionType";

export interface IOfferContentsTable {
    name: string,
    description?: string,
    addToContents?: boolean,
    entries?: IOfferContentsTableEntry[],
    entriesCustom?: boolean,
    solutionType?: OfferProductSolutionType,
    type: "bool" | "textBool" | "text" | "category" | "posts" | "support",
    boolMin?: number,
    icons?: IOfferContentsTableIcon[],
    eachMonth?: boolean,
    fixedValue?: string,
    agent?: string,
    alignCenter?: boolean
}

export interface IOfferContentsTableEntry {
    templateId?: string,
    value?: any
}

export enum IOfferContentsTableIcon {
    WORDPRESS,
    SHOPIFY,
    WIX,
    PRESTASHOP,
    WEBFLOW,
    GSC,
    ANIS,
    QUENTIN,
    JULIE,
    CELINE,
    THOMAS,
    TRISTAN
}